import { Link, useNavigate, useParams } from "react-router";
import { Kachel } from "../design/Kachel";
import { useKopfziele } from "../design/Kopfnavigation";
import { Symbol } from "../design/Symbol";
import { AnsichtDerDrueckjagd } from "./AnsichtDerDrueckjagd";
import { useStartlage } from "./Startansicht";
import { zieleDerStartansicht, zieleInMehr } from "./ziele";

/**
 * Ansicht „mehr“ (oberflaeche.md §3.1 „Ziele der Startansicht“, §3.2, V-6, V-7, V-12; Referenz `#s-mehr`): mit
 * Zustandsband; in `main` „mehr“ `button` „Zurück“ (zur vorigen Ansicht), alle weiteren Ziele der Rolle als
 * `button` und die Kopfnavigation `navigation` „Navigation“ mit allen `link`, in einem Scrollbereich.
 */
export function Mehr() {
  const { id = "" } = useParams();
  const navigate = useNavigate();
  const { rollen, beitraege } = useStartlage(id);
  const kopfziele = useKopfziele();
  // Alle weiteren Ziele der Rolle samt denen der Kontexte (z. B. „Hund gesichtet“, §4.3). Kernaktionen weiterer Rollen ohne
  // meldende Handlung („Kontrollliste“ u. a.) stehen hier zuerst: Hat die eine Reihe der Sekundärziele für sie keinen Platz
  // (K105, V-29; Startansicht.tsx `data-platz`, app.css), erreicht man sie nur hier. Meldende stehen immer direkt.
  const ziele = zieleInMehr(zieleDerStartansicht(beitraege, rollen, id), beitraege.some((b) => !!b.bereiche));
  return (
    <AnsichtDerDrueckjagd drueckjagdId={id} name="mehr" ohneMehr>
      <div className="gruppe">
        {ziele.map((z) => <Kachel key={z.begriff} symbol={z.symbol} begriff={z.begriff} art="quer" onPress={() => navigate(z.ziel)} />)}
      </div>
      <nav className="gruppe" aria-label="Navigation">
        <h2 className="kopf platte">Navigation</h2>
        {kopfziele.map(([pfad, begriff, symbol]) => (
          <Link key={pfad} to={pfad} className="k k--quer" aria-label={begriff}>
            <Symbol name={symbol} />
            <span className="k__b">{begriff}</span>
          </Link>
        ))}
      </nav>
    </AnsichtDerDrueckjagd>
  );
}
